import React from 'react'
import { Outlet } from 'react-router-dom'

export const SubOemBase: React.FC = () => {
  return <Outlet />
}
